import { apiAsync } from '../../common/helpers'

const fetchCsvFile = async ({
  product,
  filters,
  sortOptions,
  searchText,
  companyId
}) => {
  const queryParams = {
    searchText,
    sortField: sortOptions.field,
    sortDirection: sortOptions.direction,
    stateCodeFilter: filters && filters.state && filters.state.locale && filters.state.locale.state,
    product
  }

  return apiAsync({
    api: `external/companies/${companyId}/locations/export`,
    params: queryParams,
    method: 'GET'
  })
}

export default fetchCsvFile
